export enum StatusGiftType {
  Silver = 'Silver',
  Gold = 'Gold',
  Platinum = 'Platinum'
}

export enum StatusGiftIcon {
  Silver = 'DonSilver',
  Gold = 'DiamondDonGold',
  Platinum = 'LimitlessDonPlatinum'
}
